import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import { fetchRankingListFail } from '../../ranking/store';
import {
	fetchSemanticRuleListSuccess,
	initSemanticRuleList,
	refreshSemanticRuleList,
} from './semantic-rule.actions';
import { SemanticRuleState } from './semantic-rule.state';

export const semanticRuleReducer = createReducer<SemanticRuleState>(
	new SemanticRuleState(),
	on(goToProjects, setProject, (state) => state.clear()),
	on(initSemanticRuleList, refreshSemanticRuleList, (state) =>
		state.setLoading(true)
	),
	on(fetchRankingListFail, (state) => state.setLoading(false)),
	on(fetchSemanticRuleListSuccess, (state, action) =>
		state.setLoading(false).setRankingList(action.semanticRuleList)
	)
);
